import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';

import { editPet } from 'actions/pet';
import { loadUser } from 'actions/user';
import Button from 'atoms/button';
import Checkbox from 'atoms/checkbox';
import { DateInput } from 'atoms/date-input';
import Dropdown from 'atoms/dropdown';
import { editForm } from 'store/reducers/createPetForm';
import { setActivePet } from 'store/reducers/petAppointments';

export default function CreatePetDetailsInfo() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { gender, type, uuid } = useSelector(
    (state) => state.user.data?.animals?.[0],
  );
  const { data } = useSelector((state) => state.createPetForm);
  const userData = useSelector((state) => state.user.data);
  const { core } = useSelector((state) => state.main);
  const {
    dateOfBirth,
    gender: formGender,
    isSterilized,
    vaccinationIds,
  } = data;
  const canContinue = isSterilized && dateOfBirth && (gender || formGender);

  const onSubmit = (e) => {
    e.preventDefault();

    if (!canContinue) return;

    dispatch(
      editPet(
        {
          dateOfBirth,
          genderId: formGender?.id,
          isSterilized: isSterilized?.id,
          vaccinationIds,
        },
        uuid,
      ),
    ).then(({ success }) => {
      if (success) {
        dispatch(loadUser());
        dispatch(setActivePet(userData?.animals?.[0]));
        navigate('/upload-avatar');
      }
    });
  };

  return (
    <div className="create-pet">
      <h1 className="mb-15 f-14">Additional pet details</h1>
      <form onSubmit={onSubmit}>
        <div className="flex-row align-end">
          <div className="flex-column w-100 mr-10">
            <h3 className="mb-15">Date of birth</h3>
            <DateInput
              placeholder="02/02/2020"
              maxDate={new Date()}
              onChange={(value) =>
                dispatch(editForm({ key: 'dateOfBirth', value }))
              }
              value={dateOfBirth}
            />
          </div>
          {!gender && (
            <Dropdown
              label="Gender"
              placeholder="Select"
              className="w-100 mr-10"
              items={core.gender}
              onClick={(value) => dispatch(editForm({ key: 'gender', value }))}
              value={formGender?.value}
            />
          )}
          <Dropdown
            label="Spay/Neuter"
            placeholder="Select"
            className="w-100"
            items={[
              { id: true, value: 'Yes' },
              { id: false, value: 'No' },
            ]}
            onClick={(value) =>
              dispatch(editForm({ key: 'isSterilized', value }))
            }
            value={isSterilized?.value}
          />
        </div>
        {(type?.id === 1 || type?.id === 2) && (
          <div className="flex-column mt-32 mb-25">
            <h3 className="mb-15 mt-10">Vaccinations</h3>
            <div className="checkbox-container">
              {core.vaccination
                .map((el) => {
                  if (el.animalTypeId === type?.id) {
                    return (
                      <div
                        key={el.value}
                        className="checkbox-container__checkbox"
                      >
                        <Checkbox
                          id={el.id}
                          size="small"
                          value={vaccinationIds.includes(el.id)}
                          onClick={({ id }) => {
                            const ids = [...vaccinationIds];
                            if (ids.includes(id)) {
                              const index = ids.indexOf(id);
                              ids.splice(index, 1);
                            } else {
                              ids.push(id);
                            }
                            dispatch(
                              editForm({ key: 'vaccinationIds', value: ids }),
                            );
                          }}
                          text={el.value}
                        />
                      </div>
                    );
                  }
                  return null;
                })
                .filter(Boolean)}
            </div>
          </div>
        )}
        <Button
          variant={canContinue ? 'default' : 'disabled'}
          text="Next"
          type="submit"
          className="mt-25"
        />
      </form>
    </div>
  );
}
